module.exports = __webpack_public_path__ + "static/media/3.30bf78d5.png";